export default "__VITE_ASSET__z0K8lFRl__"